import { render, staticRenderFns } from "./whitelistDialog.vue?vue&type=template&id=55d8730c&scoped=true&"
import script from "./whitelistDialog.vue?vue&type=script&lang=js&"
export * from "./whitelistDialog.vue?vue&type=script&lang=js&"
import style0 from "./whitelistDialog.vue?vue&type=style&index=0&id=55d8730c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d8730c",
  null
  
)

export default component.exports